exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nli[data-v-155a07be] {\n  background-color: white;\n  list-style: none;\n}\n.statusLabel2[data-v-155a07be] {\n  padding-top: 10px;\n  padding-left: 150px\n}\n.iconStatus[data-v-155a07be] {\n  font-size: 17px;\n}\n.versionSubTitle[data-v-155a07be] {\n  margin-left: 5px;\n  color: grey;\n  font-size: 12px;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-155a07be","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/services/directPayments/DPDraftList.vue
// module id = 1535
// module chunks = 2